var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-page",class:{
    bold: _vm.bold,
    xsmallSize: _vm.xsmallSize,
    smallSize: _vm.smallSize,
    normalSize: _vm.normalSize,
    midSize: _vm.midSize,
    largeSize: _vm.largeSize,
    largeXLSize: _vm.largeXLSize,
    largeXXLSize: _vm.largeXXLSize,
    grayLight: _vm.grayLight,
    gray: _vm.gray,
    grayDark: _vm.grayDark,
    themeColor: _vm.themeColor,
    orange: _vm.orange,
    grey: _vm.grey,
    warning: _vm.warning,
    center: _vm.showIcon
  }},[(_vm.showIcon)?_c('div',{staticClass:"icon",class:{iconBook: _vm.iconBook, iconStar: _vm.iconStar, iconMark: _vm.iconMark, iconLack: _vm.iconLack, iconTesting: _vm.iconTesting}}):_vm._e(),_vm._v(" "),(_vm.showMark && (_vm.mark1 || _vm.mark2))?_c('svg',{class:{mark1: _vm.mark1, mark2: _vm.mark2}},[(_vm.mark1)?_c('circle',{attrs:{"cx":"0.08rem","cy":"0.31rem","r":"0.08rem","fill":"rgb(31, 184, 191)"}}):_vm._e(),_vm._v(" "),(_vm.mark2)?_c('circle',{attrs:{"cx":"0.2rem","cy":"0.32rem","r":"0.12rem","fill":"rgb(31, 184, 191)"}}):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"content"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dc458670","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Texts/index.vue
// module id = null
// module chunks = 